export const arrayToObject = (array, keyMapper) => {
  let km = keyMapper || (item => item.name)
  return array.reduce((obj, item) => {
    obj[km(item)] = item
    return obj
  }, {})
}
